import React from 'react';
import PropType from 'prop-types';
import ReactHighcharts from 'react-highcharts';
import {HomepageSection, HomepageSectionHeader} from "../Homepage";

class GenderChartPublic extends React.Component {
  render() {
    const config = {
      exporting: {enabled: false},
      chart: {
        type: 'bar'
      },
      title: {
        text: this.props.title
      },
      subtitle: {
        text: 'including patients documented as deceased',
      },
      xAxis: {
        categories: this.props.categories
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Total patients'
        }
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        },
        bar: {
          dataLabels: {
            enabled: true,
            align: 'center',
          },
          enableMouseTracking: false
        },
      },
      // reverse in order to display it in the right order
      series: this.props.series,
    };

    //return <ReactHighcharts config={config}/>;
    return (
        <HomepageSection style={{position: 'relative', zIndex: 2}}>
          <HomepageSectionHeader>
            <h2><span>{'Gender Distribution'}</span>
            </h2>
          </HomepageSectionHeader>
          <div className='text-center' style={{marginTop: 25, marginBottom: 25}}>
            <ReactHighcharts config={config}/>
          </div>
        </HomepageSection>
    );
  }
}

GenderChartPublic.propTypes = {
  data: PropType.array.isRequired,
};

export default GenderChartPublic;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/GenderChartPublic.js